<template>
  <div :style="wrapperDynamicStyle" class="responsive__wrapper">
    <slot />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'AResponsive',
  props: {
    aspectRatio: propValidator([PROP_TYPES.NUMBER], false, ASPECT_RATIO.SQUARE)
  },
  computed: {
    wrapperDynamicStyle() {
      if (!this.aspectRatio) return {}

      return this.$helper.generateAspectRatioStyle(this.aspectRatio)
    }
  }
}
</script>

<style lang="scss" scoped>
.responsive__wrapper {
  position: relative;
}
</style>
